"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var mobx=require("mobx"),injectStores=function(e){return window.__MOBX_DEVTOOLS_GLOBAL_STORES_HOOK__={stores:e,$mobx:mobx.$mobx},e};exports.injectStores=injectStores;
//# sourceMappingURL=index.js.map
